import { useEffect } from 'react';

export const usePageMeta = ({ title, description, ogTitle, ogDescription, ogImage }) => {
  useEffect(() => {
    // Update page title
    if (title) {
      document.title = title;
    }

    // Update or create meta description
    let metaDescription = document.querySelector("meta[name='description']");
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    if (description) {
      metaDescription.content = description;
    }

    // Update or create OpenGraph title
    let ogTitleTag = document.querySelector("meta[property='og:title']");
    if (!ogTitleTag) {
      ogTitleTag = document.createElement('meta');
      ogTitleTag.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitleTag);
    }
    ogTitleTag.setAttribute('content', ogTitle || title);

    // Update or create OpenGraph description
    let ogDescTag = document.querySelector("meta[property='og:description']");
    if (!ogDescTag) {
      ogDescTag = document.createElement('meta');
      ogDescTag.setAttribute('property', 'og:description');
      document.head.appendChild(ogDescTag);
    }
    ogDescTag.setAttribute('content', ogDescription || description);

    // Update or create OpenGraph type
    let ogTypeTag = document.querySelector("meta[property='og:type']");
    if (!ogTypeTag) {
      ogTypeTag = document.createElement('meta');
      ogTypeTag.setAttribute('property', 'og:type');
      document.head.appendChild(ogTypeTag);
    }
    ogTypeTag.setAttribute('content', 'website');

    // Update or create OpenGraph image (if provided)
    if (ogImage) {
      let ogImageTag = document.querySelector("meta[property='og:image']");
      if (!ogImageTag) {
        ogImageTag = document.createElement('meta');
        ogImageTag.setAttribute('property', 'og:image');
        document.head.appendChild(ogImageTag);
      }
      ogImageTag.setAttribute('content', ogImage);
    }

    // Update or create OpenGraph URL
    let ogUrlTag = document.querySelector("meta[property='og:url']");
    if (!ogUrlTag) {
      ogUrlTag = document.createElement('meta');
      ogUrlTag.setAttribute('property', 'og:url');
      document.head.appendChild(ogUrlTag);
    }
    ogUrlTag.setAttribute('content', window.location.href);

    // Twitter Card tags
    let twitterCardTag = document.querySelector("meta[name='twitter:card']");
    if (!twitterCardTag) {
      twitterCardTag = document.createElement('meta');
      twitterCardTag.name = 'twitter:card';
      document.head.appendChild(twitterCardTag);
    }
    twitterCardTag.content = 'summary_large_image';

    let twitterTitleTag = document.querySelector("meta[name='twitter:title']");
    if (!twitterTitleTag) {
      twitterTitleTag = document.createElement('meta');
      twitterTitleTag.name = 'twitter:title';
      document.head.appendChild(twitterTitleTag);
    }
    twitterTitleTag.content = ogTitle || title;

    let twitterDescTag = document.querySelector("meta[name='twitter:description']");
    if (!twitterDescTag) {
      twitterDescTag = document.createElement('meta');
      twitterDescTag.name = 'twitter:description';
      document.head.appendChild(twitterDescTag);
    }
    twitterDescTag.content = ogDescription || description;
  }, [title, description, ogTitle, ogDescription, ogImage]);
};
